export default "__VITE_ASSET__CZ_9HCKy__"